import { DEFAULT_ACTION_SOURCE } from '../utils/constants';
import { isItemOfMessageType } from 'owa-mail-list-store';
import replyByMeeting from 'owa-mail-reading-pane-store/lib/actions/replyByMeeting';
import { ClientItem } from 'owa-mail-store';
import Message from 'owa-service/lib/contract/Message';
import * as React from 'react';

export default function onReplyByMeeting(clientItem: ClientItem) {
    return (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();

        const message = isItemOfMessageType(clientItem) ? (clientItem as Message) : null;

        replyByMeeting(
            clientItem.ItemId.Id,
            null /*calendarInlineComposeViewState*/,
            false /*shouldSend*/,
            DEFAULT_ACTION_SOURCE,
            null /*extractionEntityId*/,
            message?.InternetMessageId /*internetMessageId*/
        );
    };
}
